export default {
    change_username_title: "Cambiar nombre de usuario",
    change_username_sim_details_error: "No fue posible obtener el detalle de la sim",
    change_username_saved_successfully: "Guardado con éxito",
    change_username_the_was_an_error_in_the_save: "Hubo un error mientras se guardaba",
    change_username_current_username: "Nombre de usuario actual",
    change_username_new_username: "Nuevo nombre de usuario",
    change_username_sim_provider_account: "Cuenta de proveedor de SIM",
    change_username_sim_sim_phone: "Teléfono Sim",
    change_username_load_phone_number: "Cargue el número de teléfono",
    change_username_iccid_minlength: "El ICCID debe tener entre 14 y 20 caracteres",
    change_username_new_username_error_min: 'El nuevo nombre de usuario debe contener un mínimo de caracteres',
    change_username_new_username_error_max: 'El nuevo nombre de usuario debe contener un máximo de caracteres',
    change_username_the_username_already_exist: 'El nombre de usuario ya existe',
}